import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const DASHBOARD_PATH = 'dashboards/422'

const FirstPurchasesAndAppAdoptionByLocationTab: React.FC = () => (
  <LookerEmbedTab
    path={DASHBOARD_PATH}
    translationKey="looker.urls.dashboards/422"
  />
)

export default FirstPurchasesAndAppAdoptionByLocationTab
